import {RefCallback} from 'react';

import {trackEvent} from 'analytics/Analytics';
import {ACTION_CATEGORY, ANALYTICS_MODULE} from 'analytics/AnalyticsTypes';
import useResizeObserver from 'ui-library/hooks/useResizeObserver';

export function trackHomepageEvent(
  action: string,
  actionCategory: ACTION_CATEGORY = ACTION_CATEGORY.READ
): void {
  trackEvent({
    module: ANALYTICS_MODULE.NAVIGATION,
    actionCategory,
    action: `new_homepage_${action}`,
  });
}

export function useIsSmall(): {isSmall: boolean; ref: RefCallback<HTMLElement>} {
  const {ref, width} = useResizeObserver();
  const isSmall = width != null && width < 450;

  return {isSmall, ref};
}
